import {
  Flex,
  HStack,
  Heading,
  Icon,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { TableIcon } from '@assets/icons';
import SettingsLayout from '@layouts/settings.layout';
import CenteredLayout from '@layouts/centered.layout';
import { useBotsUsage } from '@services/query-services/bots.query-service';
import { useUserStore } from '@store/app.store';
import { formatBytes, formatDuration } from '@util/helpers/analytics.helpers';
import { useSetDocumentTitle } from '@util/hooks';

export default function AnalyticsPage() {
  useSetDocumentTitle('Analytics - FORA');
  const tenantId = useUserStore((state) => state?.tenant)?.id;
  const { data: usageData, isLoading: isLoadingUsage } = useBotsUsage(tenantId ? [tenantId] : []);

  const usageRows = usageData
    ? [
        { label: 'Total Bots', value: usageData.count?.toLocaleString() },
        { label: 'Transcripts', value: usageData.num_of_transcripts?.toLocaleString() },
        { label: 'Media Storage', value: formatBytes(usageData.bytes_of_media) },
        { label: 'Total Duration', value: formatDuration(usageData.duration) }
      ]
    : [];

  return (
    <SettingsLayout dataCy='analytics-page'>
      <CenteredLayout gap={6}>
        <Link to='/settings/analytics/attended-meetings'>
          <Flex
            layerStyle='nav-card'
            gap={4}
          >
            <HStack gap={4}>
              <Icon
                as={TableIcon}
                boxSize={6}
                color='brandPrimary.primary'
              />
              <Heading fontSize='xl'>Attended Meetings</Heading>
            </HStack>
            <Text fontSize='sm'>This table shows all meetings that Fora has attended.</Text>
            <Text
              fontSize='14'
              color='surface.onSurfaceVariant'
            >
              Updated 5 min ago
            </Text>
          </Flex>
        </Link>
        <Link to='/settings/analytics/failed-bots'>
          <Flex
            layerStyle='nav-card'
            gap={4}
          >
            <HStack gap={4}>
              <Icon
                as={TableIcon}
                boxSize={6}
                color='brandPrimary.primary'
              />
              <Heading fontSize='xl'>Failed Bots</Heading>
            </HStack>
            <Text fontSize='sm'>This table shows the details around Fora bots failing.</Text>
            <Text
              fontSize='14'
              color='surface.onSurfaceVariant'
            >
              Updated 5 min ago
            </Text>
          </Flex>
        </Link>
        <Flex
          layerStyle='nav-card'
          gap={4}
        >
          <Heading fontSize='xl'>Usage Statistics</Heading>
          <Text fontSize='sm'>Usage data for your organization.</Text>
          {isLoadingUsage ? (
            <Spinner size='md' />
          ) : (
            <Table
              variant='simple'
              size='sm'
            >
              <Thead>
                <Tr>
                  <Th>Metric</Th>
                  <Th isNumeric>Value</Th>
                </Tr>
              </Thead>
              <Tbody>
                {usageRows.map((row) => (
                  <Tr key={row.label}>
                    <Td>{row.label}</Td>
                    <Td isNumeric>{row.value}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </Flex>
      </CenteredLayout>
    </SettingsLayout>
  );
}
